import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { SliceStackedSettings } from 'extensions/core/slice-stacked/front/slice-stacked-settings.model';


export const SliceStackedDefinition: IdtComponentDefinition = {
  id: 'slice-stacked',
  role: IdtComponentRole.Slice,
  numSlots: 1,
  defaultSlot: 1
};

export const SliceStackedCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Slice stacked',
  group: CmsComponentGroups.Basic,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): SliceStackedSettings => {
    return {
      general: {},
      styles: SliceStylesDefaultValues
    };
  }
};
